import React, { Component } from "react";
import { FlatButton, Subheader } from "material-ui";

export default class FilterIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterMessage: "",
      filterButtons: [],
      styles: {
        textButton: {
          background: "none",
          border: "none",
          margin: 0,
          padding: 0,
          cursor: "pointer",
          color: "blue",
        },
      },
    };

    this.linkFormatter = this.linkFormatter.bind(this);
    this.filterData = this.filterData.bind(this);
  }

  componentWillMount() {
    this.props.authFetchWorkorders(
      this.props.url + this.props.location.search,
      this.props.token.jwt,
    );
  }

  componentWillReceiveProps(nextProps) {
    let filterButtons = [];
    if (this.props.location.search !== nextProps.location.search) {
      this.props.authFetchWorkorders(
        this.props.url + nextProps.location.search,
        this.props.token.jwt,
      );
    } else if (
      nextProps.workOrders &&
      nextProps.filterKey &&
      !this.state.filterMessage
    ) {
      let filterKey = nextProps.filterKey;
      let filtered = nextProps.workOrders.reduce((filterObj, workOrder) => {
        if (workOrder[filterKey] in filterObj) {
          filterObj[workOrder[filterKey]]++;
        } else {
          filterObj[workOrder[filterKey]] = 1;
        }
        return filterObj;
      }, {});
      Object.keys(filtered).map((key) => {
        filterButtons.push({
          label: `${key[0].toUpperCase()}${key.slice(1)}`,
          field: key,
        });
      });
    }
    this.setState({ filterButtons: filterButtons });
  }

  linkFormatter(cell, row) {
    return (
      <button
        style={this.state.styles.textButton}
        onClick={this.props.performRoute.bind(
          this,
          `/job/communicationsManager/documentTemplates/${row._id}`,
        )}
      >
        {cell}
      </button>
    );
  }

  filterData(f) {
    let url = `${this.props.location.pathname}`;
    if (f.field != "") url += `?${this.props.filterKey}=${f.field}`;
    this.props.performRoute(url);
    this.setState({ filterMessage: f.field ? f.label : "" });
  }

  renderButton(f) {
    return (
      <FlatButton
        key={f.label}
        label={f.label}
        backgroundColor="#E0E0E0"
        hoverColor="#BDBDBD"
        style={{ margin: "0.5em" }}
        onClick={this.filterData.bind(this, f)}
      />
    );
  }

  render() {
    let filter = { type: "TextFilter", delay: 500 };

    if (this.props.isLoading) {
      return <Subheader>Please Wait</Subheader>;
    } else if (this.state.filterMessage) {
      return (
        <div>
          {this.renderButton({ label: "Clear", field: "" })}
          <Subheader>
            Showing {this.props.workOrders.length} results for{" "}
            <strong>{this.state.filterMessage}</strong>
          </Subheader>
        </div>
      );
    } else if (this.state.filterButtons.length > 1) {
      return (
        <div>
          {this.state.filterButtons.map((f) => this.renderButton(f))}
          <Subheader>Click a button to filter the table</Subheader>
        </div>
      );
    } else return null;
  }
}



// WEBPACK FOOTER //
// ./app/components/FilterIndex.js